export default __webpack_public_path__ + "static/129-67ead30ed16295772db51d3116129262.jpg";